const MappingRisksTypes = {
  POST_HISTORY_MAPPING: "POST_HISTORY_MAPPING",
  GET_HISTORY_MAPPING_SUCCESS: "GET_HISTORY_MAPPING_SUCCESS",
  GET_HISTORY_MAPPING: "GET_HISTORY_MAPPING",
}

export default MappingRisksTypes
